<button disableTabOnModal [attr.id]="id" [ngClass]="class" [type]="buttonType" [disabled]="disabled" (click)="wasClicked()" [attr.aria-label]="ariaLabel">
    <ng-container *ngIf="!isLoading">
        {{text}}
    </ng-container>
    <div class="u-flex c-animation c-anmation-FadeInUp fadeInUp u-flex-center" *ngIf="isLoading">
        <div class="c-loader u-mleft-xsm"></div>
        &nbsp; {{submittingText}}
    </div>
</button>
